import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/icon-perfil-politico.svg'
import _imports_2 from '@/assets/icons/icon-historico.svg'
import _imports_3 from '@/assets/icons/icon-patrimonio.svg'
import _imports_4 from '@/assets/icons/icon-representatividade.svg'


const _hoisted_1 = { class: "home bg-background-light" }
const _hoisted_2 = { class: "home__container" }
const _hoisted_3 = { class: "home__banner bg-primary-base p-5 flex" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "home__banner-logo flex justify-center self-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Perfil Político"
}, null, -1)
const _hoisted_7 = { class: "flex justify-center items-center h-4/5" }
const _hoisted_8 = { class: "home__banner-content text-white font-bold uppercase" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"home__banner-content-emphasis flex items-center flex-col sm:flex-row mb-3\"><div class=\"sm:pr-5 mb-4\"><img src=\"" + _imports_1 + "\" alt=\"Ícone Perfil Político\"></div><div><h1 class=\"home__banner-content-emphasis_title text-white text-xl sm:text-4xl uppercase sm:text-left\"> Conheça o Perfil Político das <br><span class=\"text-secondary-base\">pessoas candidatas em 2022</span></h1></div></div>", 1)
const _hoisted_10 = { class: "home__banner-content-action flex flex-col w-full mt-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center text-white" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-regular text-lg" }, "Por que usar o Perfil Político?"),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 animate__animated animate__bounce animate__infinite",
    fill: "none",
    stroke: "#FFFFFF",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 9l-7 7-7-7"
    })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<section class=\"home__differentials bg-background-light relative px-5\"><div class=\"container relative\"><div class=\"home__differentials_content absolute bg-white text-center -top-16 p-10 rounded-3xl\"><h2 class=\"home__differentials_title text-primary-base uppercase font-bold sm:text-4xl text-center text-xl\"> Diferenciais do Perfil Político </h2><div class=\"mt-16 block sm:grid grid-flow-col gap-36\"><div class=\"flex flex-col justify-start items-center\"><img src=\"" + _imports_2 + "\" alt=\"Visualização da trajetória política\" class=\"w-32\"><h4 class=\"text-primary-base text-xl font-bold my-3\"> Visualização da trajetória política </h4><p class=\"text-text-light font-regular text-base\"> Você pode comparar e conhecer o histórico das milhares de candidaturas, as mudanças de partido, eleições disputadas e ganhas. </p></div><div class=\"flex flex-col justify-start items-center\"><img src=\"" + _imports_3 + "\" alt=\"Patrimônio do candidato\" class=\"w-32\"><h4 class=\"text-primary-base text-xl font-bold my-3\"> Histórico do patrimônio declarado </h4><p class=\"text-text-light font-regular text-base\"> A ficha de cada pessoa candidata apresenta o patrimônio declarado patrimônio declarado ao longo de todas as eleições disputadas e a comparação com o patrimônio das outras candidaturas do mesmo ano. </p></div><div class=\"flex flex-col justify-start items-center\"><img src=\"" + _imports_4 + "\" alt=\"Análise de representatividade\" class=\"w-32\"><h4 class=\"text-primary-base text-xl font-bold my-3\"> Análise de representatividade </h4><p class=\"text-text-light font-regular text-base\"> Veja como está a representatividade de gênero e cor/raça de todas as candidaturas para um cargo - e se as pessoas, de fato, representam você. </p></div></div></div></div></section>", 1)
const _hoisted_13 = { class: "home__about bg-background-light sm:mt-20" }
const _hoisted_14 = { class: "home__about-content container px-5 sm:grid sm:grid-cols-9 sm:gap-16 py-20" }
const _hoisted_15 = { class: "col-span-3 col-start-2 flex items-center justify-center" }
const _hoisted_16 = { class: "col-span-4 flex flex-col justify-center sm:items-start items-center container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-base uppercase font-bold sm:text-4xl sm:text-left text-center text-xl" }, " Sobre o Perfil Político ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-text-light my-10 sm:text-2xl sm:text-left text-center text-base font-regular" }, " O Perfil Político é uma plataforma desenvolvida pela Open Knowledge Brasil para tornar mais acessíveis as informações sobre a trajetória das pessoas candidatas. A ferramenta utiliza dados abertos por órgãos como o Tribunal Superior Eleitoral e a Receita Federal do Brasil e tem seu código aberto para colaboração. Com ela, a população pode consultar e comparar candidaturas do ponto de vista de gênero, raça/cor, dentre outras características. ", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Saiba mais ")
const _hoisted_20 = {
  class: "home__common-questions bg-background-light sm:py-20 py-10",
  id: "perguntas-frequentes"
}
const _hoisted_21 = { class: "container px-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-base uppercase font-bold sm:text-4xl text-center text-xl sm:mb-16 mb-5" }, " PERGUNTAS FREQUENTES ", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Você pode achar dados sobre todas as candidaturas aos cargos de deputado(a) federal, estadual e distrital, senador(a), governador(a) e presidente(a) nas eleições gerais de 2022. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Para fazer uma comparação entre pessoas candidatas ao mesmo cargo: ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("ol", { class: "ml-8 mt-2 list-decimal" }, [
  /*#__PURE__*/_createElementVNode("li", null, " Selecione um cargo e o estado (não se aplica em consulta de presidenciáveis ou deputado(a) distrital) e clique em “COMPARAR CANDIDATURAS”; "),
  /*#__PURE__*/_createElementVNode("li", null, " No menu de “Filtros” (barra lateral em dispositivos de mesa e topo da tela em dispositivos móveis) é possível filtrar por partidos ou alterar o cargo ou estado escolhido; "),
  /*#__PURE__*/_createElementVNode("li", null, " Acima da grade de candidaturas, ao expandir o menu de “Filtro por Análises”, em roxo, você poderá clicar nas perguntas que desejar e isso fará com que as candidaturas apresentadas na listagem correspondam apenas às perguntas realizadas. A análise da representatividade aparece em gráfico; "),
  /*#__PURE__*/_createElementVNode("li", null, " A qualquer momento você pode clicar em uma pessoa candidata da grade e isso levará à página com informações detalhadas do perfil dela. ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Você pode buscar por uma candidatura específica selecionando um cargo e o estado (não se aplica em consulta de presidenciáveis ou deputado(a) distrital). Em seguida, digite o nome da pessoa no campo “TEM UMA PESSOA CANDIDATA EM MENTE?”, e selecione o nome da lista que aparece. Por fim, é só clicar no botão “BUSCAR” e visualizar o perfil da pessoa candidata. ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" A plataforma foi desenvolvida pelo programa ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", null, "Ciência de Dados para Inovação Cívica", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" da ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://ok.org.br/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Open Knowledge Brasil", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(". Em 2018, a primeira versão da plataforma foi realizada em parceria com o site ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://theintercept.com/brasil/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "The Intercept Brasil", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" e o ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://brasil.io/home/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Brasil.io", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" A fonte primária dos dados, ou seja, de onde eles foram retirados, é o Tribunal Superior Eleitoral (TSE). Outras fontes também são utilizadas, como a Câmara dos Deputados, o Senado Federal e a Receita Federal, e os dados estão disponíveis através da API para serem utilizados por outros projetos, como o ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://parlametria.org.br/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Parlametria", -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(". Você pode obter esses dados, já organizados, no ")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://brasil.io/home/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Brasil.io", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(", no ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/cuducos/raspadorlegislativo",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Raspador Legislativo", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" e na ")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://serenata.ai/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Operação Serenata de Amor", -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" A ficha dos candidatos reúne informações básicas como idade, gênero, cor/raça, escolaridade e ocupação, mas também dados sobre patrimônio declarado em todas as eleições disputadas, mudanças de partidos, histórico de candidaturas e de eleições ganhas. ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, " Os dados do TSE foram coletados pelo TSE estão sendo coletados continuamente à medida que estão sendo disponibilizados desde o início de agosto de 2022, logo após o TSE oficializar as candidaturas para as eleições gerais de 2022 e começar a disponibilizá-los em 20 de julho. ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, " A série histórica de filiação partidária deixou de ser publicada pelo TSE em razão da Lei Geral de Proteção de Dados (LGPD) em agosto de 2021. Apenas as filiações ativas passaram a ser disponibilizadas poucos meses antes das eleições. A última versão do histórico partidário armazenada pelo Perfil Político é do final de 2020 e as filiações atuais foram coletadas em agosto de 2022. ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, " Os dados da Câmara dos Deputados e do Senado Federal foram coletados em julho de 2022 e os dados da Receita Federal foram coletados em outubro de 2021. ", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" O TSE oferece duas formas para os cidadãos acessarem os dados. Um é um site navegável para humanos, o ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://divulgacandcontas.tse.jus.br/divulga/#/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Divulgação de Candidaturas e Contas Eleitorais", -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(", outro é o ")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://dadosabertos.tse.jus.br/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Portal de Dados Abertos", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(", que oferece dados em massa, legíveis por máquinas. Em raros casos o site diverge do portal, então existem chances da diferença ser uma inconsistência do próprio TSE ou uma atualização no portal que ainda não foi incorporada ao ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-base" }, "Perfil Político", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" O projeto foi desenvolvido com recursos da ")
const _hoisted_57 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://ok.org.br/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "Open Knowledge Brasil", -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode(". O ")
const _hoisted_59 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://theintercept.com/brasil/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "The Intercept Brasil", -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" apoiou o projeto cobrindo os custos de infraestrutura tecnológica para armazenamento dos dados durante sua criação em 2018. Para que a equipe do projeto possa continuar aperfeiçoando esse e outros projetos do ")
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", null, "Programa de Ciência de Dados para Inovação Cívica", -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(", dependemos das contribuições dos nossos usuários, que podem doar pelo site ")
const _hoisted_63 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://apoia.se/serenata",
  target: "_blank",
  class: "font-bold hover:underline"
}, "apoia.se/serenata", -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-base" }, "Perfil Político"),
  /*#__PURE__*/_createTextVNode(" é uma plataforma para comparar e conhecer o histórico das milhares de candidaturas às eleições. A ferramenta ajuda o eleitorado a selecionar as pessoas candidatas pelos seus perfis: você pode filtrar por pessoas novas e antigas na política. Pode ver como o seu estado está em termos de representatividade de gênero e cor/raça – e se as candidaturas, de fato, representam você. ")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, " A ficha das pessoas candidatadas reúne informações básicas como idade, gênero, cor/raça, escolaridade e ocupação, mas também dados sobre patrimônio declarado em todas as eleições disputadas, mudanças de partidos, histórico de candidaturas e de eleições ganhas ", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Sim! Temos dois repositórios com o código que faz o ")
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-base" }, "Perfil Político", -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" funcionar. Um para a ")
const _hoisted_70 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/okfn-brasil/perfil-politico",
  target: "_blank",
  class: "font-bold hover:underline"
}, "API", -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" que é em Python (Django), e outro para a ")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/okfn-brasil/perfil-politico-frontend/",
  target: "_blank",
  class: "font-bold hover:underline"
}, "interface", -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" que é JavaScript (Vue), HTML e CSS. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormSearchCandidate = _resolveComponent("FormSearchCandidate")!
  const _component_IconPP = _resolveComponent("IconPP")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'Home' } }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_FormSearchCandidate)
                ])
              ])
            ])
          ]),
          _hoisted_11
        ])
      ]),
      _hoisted_12,
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_IconPP)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createVNode(_component_router_link, {
              type: "button",
              class: "text-primary-base uppercase font-bold bg-secondary-base hover:bg-secondary-light font-medium rounded-full text-sm px-12 py-4 text-center mr-2 mb-2",
              to: { name: 'About' }
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_Accordion, { title: "Quais candidaturas posso analisar no Perfil Político?" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Como faço para realizar uma comparação de candidaturas?" }, {
            default: _withCtx(() => [
              _hoisted_24,
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Como utilizo a busca por nome?" }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Quem desenvolveu e mantém o Perfil Político?" }, {
            default: _withCtx(() => [
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "De onde vêm os dados do Perfil Político?" }, {
            default: _withCtx(() => [
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _hoisted_40,
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _hoisted_44
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Quais dados são utilizados na plataforma?" }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Quando os dados foram coletados? Eles são atualizados com alguma periodicidade?" }, {
            default: _withCtx(() => [
              _hoisted_46,
              _hoisted_47,
              _hoisted_48
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Encontrei dados na plataforma que estão diferentes dos dados encontrados no site do TSE, por quê?" }, {
            default: _withCtx(() => [
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53,
              _hoisted_54,
              _hoisted_55
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Como a plataforma é financiada?" }, {
            default: _withCtx(() => [
              _hoisted_56,
              _hoisted_57,
              _hoisted_58,
              _hoisted_59,
              _hoisted_60,
              _hoisted_61,
              _hoisted_62,
              _hoisted_63,
              _hoisted_64
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "Qual o objetivo da ferramenta?" }, {
            default: _withCtx(() => [
              _hoisted_65,
              _hoisted_66
            ]),
            _: 1
          }),
          _createVNode(_component_Accordion, { title: "O código da plataforma é aberto?" }, {
            default: _withCtx(() => [
              _hoisted_67,
              _hoisted_68,
              _hoisted_69,
              _hoisted_70,
              _hoisted_71,
              _hoisted_72,
              _hoisted_73
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}